import { Tappa } from './tappa.model';
import { Immagine } from './immagine.model';
import { Word } from './word.model';
import { Allegati } from './allegati.model';

export class SchedaIntense {
    constructor(
        id, name, descrizione, numerocondivisioni
    ) { 
        this.id = id;
        this.name = name;
        this.descrizione = descrizione;
        this.numerocondivisioni = 10;
    }
    
    id: number;
    name?: string;
    title?: string;
    descrizione?: string;
    condiviso?: boolean;
    numerocondivisioni?: number;
    locale?: string;
    tappe?: Tappa[];
    immagine?: Immagine[];
    created?: any;
    durata?: string;
    distanza?: string;
    changed?: any;  
    selected?: boolean;
    geom?:any;
    rete?: Word[];
    allegati: Allegati[];
    titolo?: string;
    durata_percorso?: number;
    status?: string;
    fruizione?: Word[];
    stato_fondo?: Word[];
    tipo_fondo?: Word[];
    difficolta?:Word[];
    mezzi?: Word[];
    segnaletica?: Word[];
    tematica?: Word[];
    tipologia?: Word[];
    percorrenza?: number;
    disl_positivo?: number;
    disl_negativo?: number;
    pendenza_max?:number;
}
